import { createFileRoute } from '@tanstack/react-router';

type Search = {
  quickFillTray?: 'manage-list';
};

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/contacts/lists')({
  validateSearch: (search: Search) => {
    return {
      quickFillTray: search.quickFillTray || undefined,
    };
  },
});
